export default {
  error: {
    required: 'Field is required',
    forbiddenSymbols: 'Some symbols are forbidden',
    numeric: 'Field must be numeric',
    minMax: 'Field must be between {0} and {1} characters',
    email: 'Invalid Email',
    amount: 'Invalid Amount',
    selectedPlayer: 'Please select a player',
    passwordsMismatch: 'Passwords Mismatch',
    samePasswords: 'New and old passwords are the same',
    signInUp: {
      1: 'Username does not exist',
      2: 'Password is incorrect',
      422: 'This username is already taken',
      4: 'The password must contain both letters and digits with 6 - 16 characters',
      5: 'Please provide a valid email',
      6: 'This Email not connected to any account.',
      7: 'Field is empty',
      8: 'The username must be at least 3 symbols',
      9: 'Max symbols 16',
      10: 'No spaces',
      11: 'Please Accept terms and conditions'
    },
    invalidTableName: 'Invalid table name'
  },
  messages: {
    joinClubSucces: 'Successfully sent join request.',
    createClubSuccess: 'Successfully created new club.',
    balanceTransferSuccess: 'Transfer is done successfully.',
    waitingForData: 'waiting for a data',
    deleteSuccess: 'Successfully deleted the account',
    changePasswordSuccess: 'Successfully changed the password',
    forgotPasswordSuccess: 'Your request is sent successfully',
    counterMessage1: 'Send {0} to {1}',
    clubWrongBalanceMessage1:
      'You have only {0} but you want to transfer total {1} please add clubBalance and try again',
    claimBackWrongMessage1: 'You want claim back {0} but {1} have only {2}',
    counterMessage2: 'Withdraw {0} from {1}',
    emailDeleteInfo: 'Emails will be deleted after 30 days',
    subFotterText: 'Terms and Conditions',
    changeRoleConfirmation:
      'Are you sure you want to change user permissions from ',
    bonusSuccess: 'Congratulations, you have received {0} bonus!',
    clubPlayerRemove: 'Sure to quit the club?',
    unableExport: 'Export reports is not available for your account',
    noMessages: "You don't have any messages",
    deleteMessages: 'Delete messages',
    deleteMessageInfo:
      'This message will be automatically deleted after 30 days',
    accountPrivilegeChange: {
      header: 'Account Privilege Change Request',
      body: 'Your account privileges in {0} club has been changed to {1}'
    },
    removeFromClub: {
      header: 'Remove from Club Notification',
      body: 'Your account has been removed from {0} club.'
    },
    joinRequest: {
      header: 'New Join Request',
      body: 'You have a new join request to your {0} club from {1} player'
    },
    joinedToClub: {
      header: 'You have joined to a new club',
      body: 'You have joined to {0} club.'
    },
    balanceUpdate: {
      header: 'Balance Update Request',
      body: 'Your balance in {0} club has been changed. New balance is {1}.'
    },
    productExpiration: {
      header: 'Club Product will expire soon',
      body: 'Club product {0} will expire in 1 hour, at {1}. \n Renew now.'
    },
    levelExpiration: {
      header: 'Club Rating will expire soon',
      body: 'Club rating will expire in 1 day, at {0}. \n Renew now.'
    }
  },
  signInUp: {
    username: 'Username',
    password: 'Password',
    agreement: 'I have read {0} and {1}',
    termsLink: 'Terms and Conditions',
    privacyLink: 'Privacy Policy'
  },
  tabTitle: {
    casino: 'Casino',
    regular: 'Casino',
    liveCasino: 'Live Casino',
    poker: 'Poker',
    betting: 'Sport',
    members: 'Members',
    newMembers: 'New Members',
    trade: 'Trade',
    tradeRecord: 'Trade Record',
    selectDownline: 'Select Downline',
    grantCredit: 'Grant Credit',
    currentDownline: 'Current Downline'
  },
  maxClaimBack: 'Max Claim back per player: {0}',
  cancel: 'Cancel',
  confirm: 'Confirm',
  from: 'from',
  to: 'to',
  days: 'days',
  sendVip: 'Send VIP',
  all: 'all',
  returnToClubLobby: 'Return to club lobby',
  returnToHomePage: 'Return to home page',
  downline: 'downline',
  downlines: 'downlines',
  pleaseWait: 'Please wait',
  allTime: 'All Time',
  last7Days: 'Last 7 days',
  dialogTitleEmail: 'EMAIL',
  vipStatusOff: 'Inactivated',
  vipValidDate: '(Valid for 30 days)',
  logInNow: ' Log in now',
  haveAnAccount: 'Have an account ? ',
  dialogTitlePopUp: 'Email Popup',
  member: 'Member',
  manager: 'Manager',
  agent: 'Agent',
  player: 'Member',
  assistant: "Assistant",
  userId: 'User ID',
  details: 'Details',
  uplineAgent: 'Upline Agent',
  buyProduct: 'Buy Product',
  leagueHeader: 'League',
  gamesCareer: 'Games career',
  total: 'Total',
  tips: 'Tips',
  doYouConfirm: 'Do you confirm ',
  game: 'Game',
  games: 'Games',
  sport: 'Sport',
  sports: 'Sports',
  poker: 'Poker',
  casino: 'Casino',
  regular: 'Casino',
  liveCasino: 'Casino Live',
  cashout: 'Cashout',
  multiBet: 'Multi-bet',
  systemBet: 'System bet',
  margin: 'Margin',
  theme: 'Theme',
  playerWinnings: 'Player Winnings',
  winnings: 'Winnings',
  hand: 'Hands',
  join: 'Join',
  joinClub: 'Join Club',
  joinUnion: 'Join A Union',
  createAClub: 'Create a club',
  codeForClubCreation: 'Enter code for the club creation',
  sentTo: 'Sent to',
  exchange: {
    chips: 'Chips',
    sapphires: 'Sapphires',
    currentBalance: 'Current Balance',
    currentExchange: 'Current Exchange',
    sapphireExchange: '{0} Sapphires = {1} Chips',
    minExchangeAmount: 'Minimum Exchange amount',
    convert: 'Convert'
  },
  createUnion: 'Create A Union',
  grandCreditHistory: 'Grand Credit History',
  soundEffects: 'Sound Effects',
  memberEditing: 'MEMBER EDITING',
  timeSliderName: 'Action Time',
  blindSliderName: 'Blind',
  gameLengthSliderName: 'Game Length',
  buyInSliderName: 'Buy-in',
  minBuyInText: 'Min Buy-in: ',
  maxBuyInText: 'Max Buy-in: ',
  newTableDialogTitle: 'New Table',
  blinds: 'Blinds',
  clubLeague: 'League Games',
  clubCapitalize: 'Club',
  clubId: 'Club ID',
  unionId: 'Union ID',
  agentId: 'Agent ID',
  id: 'ID',
  lv: 'Lv',
  fee: 'Fee',
  rake: 'Rake',
  pokerGames: 'Poker Games',
  spins: 'Casino Spins',
  bettings: 'Bettings',
  wl: 'Winnings',
  nickname: 'Nickname',
  lastLogin: 'Last login',
  create: 'Create',
  createClub: 'Create Club',
  selectAvatar: 'Select Avatar',
  selectCountry: 'Select Country',
  clubCreation: 'Club Creation',
  clubDescriptionAndRules: 'Club Description and Rules',
  hands: 'Hands',
  validFor: 'Valid for',
  levelUpdate: 'Level Update',
  wantToBuy: 'Do you want to buy',
  ourSubItem: 'Our SubItem',
  createNewClub: 'Create a new club',
  joinNewClub: 'Join A Club',
  clubName: 'Club Name',
  clubNotice: 'Club Notice',
  content: 'Content',
  clubDisband: 'Are you certain you wish to disband the club?',
  deleteClubMember: 'Are you sure you want to delete this member?',
  changeRole: 'Confirm to change user {0} role from {1} to {2}?',
  changeRoleFromAgent:
    "Current downline's data will be removed if you change this Agent's rights. Are you sure?",
  freeToRename: 'Free to rename for the first time',
  welcomeMessagePart1: 'Welcome to ',
  welcomeMessagePart2: 'For enquiries please contact',
  loadingTablesList: 'Loading tables list...',
  notificationIsValid: 'Every notification is valid for 24 hours',
  jackpot: 'Jackpot',
  commision: 'Commision',
  selectDownline: 'Select Downline',
  recruitedByTheAgent: 'Please tick the players recruited by the agent',
  levelHasExpired: 'Your club level has expired, please renew.',
  grantSendOutLimit: 'Grant Send out limit to the agent',
  currentDownline: 'Current Downline',
  agentManagement: 'Agent Management',
  wantToChangeDownline: 'Are you sure you want to change downline of ',
  wantToRemove: 'Do you really want to remove',
  notifications: 'Notifications',
  quitTheClub: 'Quit the club',
  oddDefaultFormat: 'Odds default format',
  clubChipBalance: 'Club Chips Balance',
  exchangeSapphires: '100 Sapphires = 40',
  multipleOf100: 'Please enter an integral multiple of 100',
  clubEditing: 'Club Editing',
  startAnewTable: 'Start a new table',
  change: 'Change',
  coins: 'Coins',
  items: 'Items',
  sapphires: 'Sapphires',
  clubHeadline1:
    'There is no denying the fact the success of an advertisement lies mostly in the headline. The headline should attract the',
  showMore: 'show more',
  clubHeadline2:
    'reader and make him read the rest of the advertisement.The headline should be simply catchy and various key points should be embedded when deciding on the headline for the ad. The headline should',
  showLess: 'show less',
  disbandClub:
    ' In order to confirm disbanding the Club, please type your club id in the input field.',
  disbandUnion:
    ' In order to confirm disbanding the Union, please type your Union id in the input field.',
  quitTheUnion:
    ' In order to confirm quitting the Union, please type your Union ID in the input field.',
  overall: 'Overall',
  yesterday: 'Yesterday',
  past7Days: 'Last 7 Days',
  lastWeek: 'Last Week',
  currentWeek: 'Current Week',
  select: 'Select',
  overallWinnings: 'Overall Winnings',
  pokerWinnings: 'Poker Winnings',
  casinoWinnings: 'Casino Winnings',
  bettingWinnings: 'Betting Winnings',
  pokerFeeAmount: 'Poker Fee Ammount',
  pokerFee: 'Poker Fee',
  overallWL: 'Overall W/L',
  pokerWL: 'Poker W/l',
  casinoWL: 'Casino W/L',
  liveCasinoWL: 'Live Casino W/L',
  sportsWL: 'Sports W/L',
  gamesPoker: 'Poker Games',
  spinsCasino: 'Casino Spins',
  deleteMember: 'Delete Member',
  dateCreated: 'Time Joined',
  chipBalance: 'Chip Balance',
  sent: 'Sent',
  totalChips: 'Total players Chips Excludes Chips in Play',
  yourChipsAmount: 'Your Chips Amount',
  chipsAmount: 'chips amount',
  totalPlayersChipsAmount: 'Total Player Chips Excludes Chips In Play',
  claimedBack: 'Claimed Back',
  tradeCommission: '{0}% commission charged for this trade',
  areComingSoon: ' are coming soon',
  nlh: 'NLH',
  plo: 'PLO',
  ofc: 'OFC',
  ringGame: 'Ring Game',
  sng: 'SNG',
  mtt: 'MTT',
  regularMode: 'Regular Mode',
  progressiveMode: 'Progressive',
  ultimateMode: 'Ultimate',
  sixPlus: '6+',
  fourCard: '4 card',
  fiveCard: '5 card',
  concurrent: 'Concurrent',
  sequential: 'Sequential',
  operationSequence: 'Operation Sequence',
  autoStart: 'Auto Start',
  autoExtension: 'Auto Extension',
  times: 'Times',
  autoOpen: 'Auto Open',
  riskManagement: 'Risk Management',
  multiTimeRun: 'Run it Multi-Times',
  evChop: 'Ev Chop',
  cap: 'Cap',
  callTime: 'Calltime',
  autorizedToBuyin: 'Autorized to Buy in',
  byh: 'Bet Your Hand',
  gpsRestriction: 'GPS Restriction',
  ipRestriction: 'IP Restriction',
  banChatting: 'Ban Chatting',
  tableCost: 'Table Cost',
  balance: 'Balance',
  pokerFee: 'Poker Fee',
  grantCredit: 'Grant Credit',
  selectDownlineText:
    'Mark the players which you want to assign to this downline',
  creditBalance: 'Credit Balance',
  clubBalance: 'Club Balance',
  grantCreditText: 'From here you can Send Out and Claim Back Club Chips',
  unionClubs: 'Union',
  unionJoinRequests: 'Join Requests',
  unionData: 'Union Data',
  unionEditingContent: {
    change: 'Change',
    label: 'Union Name',
    notice: 'Free to rename for the first time',
    save: 'Save',
    price: 'Change club Name',
    notEnough: [
      "You don't have enogh sapphires, ",
      'press here',
      ' to buy sapphires.'
    ]
  },
  information: 'Information',
  dataIsRecordedBasedOnUnionHeadData:
    'Data is recorded based on the Union Head time zone: ',
  pokerWinLossFee: 'Poker Win / Lose + Fee',
  pokerWinLossFeeOverall: 'Overall',
  pokerWinLossFeeLastWeek: 'Last week',
  pokerWinLossFeeThisWeek: 'This week',
  suspend: 'Suspend',
  remove: 'Remove',
  exportData: 'Export Data',
  betYourHand: {
    combinations: 'Combinations',
    amount: 'X1 / X2',
    max: 'Max',
    nlh: [
      {
        title: 'QQ Royal Flush',
        description:
          '(A234567 in any suit using both of your hole cards and all 5 cards on the board)',
        amount: '100.000',
        max: '250.000',
        combinations: 'QQRoyalFlush'
      },
      {
        title: 'Super Royal Flush',
        description:
          'AKQJT in 1 suit, using both of your hole cards and the first 3 cards on the board',
        amount: '30.000',
        max: '50.000',
        combinations: 'superRoyalFlush'
      },
      {
        title: 'Royal Flush',
        description: 'AKQJT in 1 suit',
        amount: '10.000',
        max: '10.000',
        combinations: 'royalFlush'
      },
      {
        title: 'Straight Flush',
        description: 'Any straight in 1 suit',
        amount: '1.500',
        max: '1.500',
        combinations: 'straightFlush'
      },
      {
        title: 'Four of a Kind',
        description: 'Any 4 of a kind',
        amount: '200',
        max: '200',
        combinations: 'fourOfKind'
      },
      {
        title: 'Full House Aces',
        description: '3 Aces + 2 cards same rank',
        amount: '100',
        max: '100',
        combinations: 'fullHouseAces'
      },
      {
        title: 'Ace High Straight',
        description: 'Straught, Ace High AKQJT',
        amount: '10',
        max: '10',
        combinations: 'aceHighStraight'
      },
      {
        title: 'Ace High Flush',
        description: 'Ace + Any 4 cards in the same suit',
        amount: '10',
        max: '10',
        combinations: 'aceHighFlush'
      },
      {
        title: 'Three of a Kind Aces',
        description: '3 Aces',
        amount: '10',
        max: '10',
        combinations: 'threeOfKindAces'
      }
    ],
    plo: [
      {
        title: 'QQ Royal Flush',
        description: 'A234567 in any suit',
        amount: '100.000',
        max: '250.000',
        combinations: 'QQRoyalFlush'
      },
      {
        title: 'Super Royal Flush',
        description:
          'AKQJT in 1 suit, using both of your hole cards and the first 3 cards on the board',
        amount: '30.000',
        max: '50.000',
        combinations: 'superRoyalFlush'
      },
      {
        title: 'Royal Flush',
        description: 'AKQJT in 1 suit',
        amount: '10.000',
        max: '10.000',
        combinations: 'royalFlush'
      },
      {
        title: 'Straight Flush',
        description: 'Any straight in 1 suit',
        amount: '1.500',
        max: '1.500',
        combinations: 'straightFlush'
      },
      {
        title: 'Four of a Kind',
        description: 'Any 4 of a kind',
        amount: '200',
        max: '200',
        combinations: 'fourOfKind'
      },
      {
        title: 'Full House Aces',
        description: '3 Aces + 2 cards same rank',
        amount: '100',
        max: '100',
        combinations: 'fullHouseAces'
      },
      {
        title: 'Ace High Straight',
        description: 'Straught, Ace High AKQJT',
        amount: '10',
        max: '10',
        combinations: 'aceHighStraight'
      },
      {
        title: 'Ace High Flush',
        description: 'Ace + Any 4 cards in the same suit',
        amount: '10',
        max: '10',
        combinations: 'aceHighFlush'
      }
    ]
  },
  exportRecord: 'Export Record',
  exportDate: 'Export Date',
  pleaseEnterValidEmail: 'Please enter a valid email',
  playerData: 'PlayerData',
  sapphireStatement: 'Sapphire Statement',
  tradeRecord: 'Trade Record',
  tradeRecords: 'Trade Records',
  upgradeToJoinText:
    'Your club should be Rank 2 or above in order to join a Union',
  upgradeToCreateText:
    'Your club should be Rank 2 or above in order to create a Union',
  clubDataHelp: [
    ['Overall', 'Displays data since the user joined the club'],
    ['Past 7 Days', 'Displays data of the past 7 days'],
    ['Select', 'Displays data of the selected dates.'],
    [
      'Overall Winnings',
      'Displays data of how many chips user won/lose throught all games.'
    ],
    [
      'Poker Winnings',
      'Displays data of how many chips user won/lost throught Poker games.'
    ],
    [
      'Casino Winnings',
      'Displays data of how many chips user won/lost throught Casino games.'
    ],
    // ['Betting Winnings', 'Displays data of how many chips user won throught Betting.'],
    ['Fee Amount', 'Shows amount of Poker Fee’s given to the club']
  ],
  footer: {
    items: {
      home: 'Home',
      shop: 'Shop',
      career: 'Career',
      profile: 'Profile',
      messages: 'Messages',
      settings: 'Settings',
      data: 'Data',
      members: 'Members',
      counter: 'Counter'
    }
  },
  agentDetails: {
    memberAmount: 'Member Amount {0}'
  },
  language: {
    en: 'English',
    tr: 'Turkish',
    id: 'Indonesian',
    de: 'German',
    ar: 'Arabic',
    fr: 'French',
    pt: 'Portuguese',
    it: 'Italian',
  },
  dialog: {
    tutorial: 'Tutorial',
    createClub: 'Create Club',
    createAClub: 'Create a Club',
    joinClub: 'Join Club',
    selectAvatar: 'Select avatar',
    selectCountry: 'Select Country',
    coins: 'Coins',
    notification: 'Notification',
    sapphires: 'Sapphires',
    exchange: 'Exchange',
    editClub: 'Club Editing',
    disbandClub: 'Disband The Club',
    disbandUnion: 'Disband The Union',
    deleteMember: 'Confirmation',
    editMemberInfo: 'Edit Member Info',
    changeRole: 'Confirmation',
    mission: 'Missions',
    unionNotice: 'Union Notice',
    joinUnion: 'Join A Union',
    createUnion: 'Create A Union',
    createLabel: 'Enter Union Name',
    joinLabel: 'Enter Union ID',
    unionAuthority: 'Authority',
    selectAuthority: {
      text: 'Select the authority to create Poker tables',
      current: 'Current Club Owners and Managers',
      all: 'All Club Owners and Managers'
    },
    unionConfirm: 'Confirm',
    unionTerms: {
      one:
        '1. Only two-star Clubs or above are able to create or join a Union.',
      two:
        '2. After creating or joining a Union, Chips retained in your club will still be available in that particular Union. However, Chips held by the agents and players will be removed',
      agreement: 'I have read the terms and conditions'
    },
    clubDetails: 'Club Details',
    upgradeToCreate: 'Can not Create a Union',
    upgradeToJoin: 'Can not Join a Union',
    unionConfirmation: 'Union Details',
    clubConfirmation: 'Club Details',
    renewLevel: 'Can not Create the Table',
    agentDetails: 'Agent Details',
    quitTheUnion: 'Quit The Union',
    export: 'Export',
    notEnoughFunds: 'Not Enough Funds',
    quitTheUnion: 'Quit The Union',
    memberMenu: 'Club Details',
    betYourHand: 'Odds',
    enterAmount: 'Please enter the amount'
  },
  settings: {
    text: 'Settings',
    twoStepVerification: 'Two Step Verification',
    changePassword: 'Change Password',
    changeEmail: 'Change Email',
    languages: 'Languages',
    avatar: 'Avatar',
    details: 'Details',
    linkEmail: 'Link Your Email',
    language: 'Language',
    select: 'Select',
    logOut: 'Log Out'
  },
  clubLevelName: {
    11: 'Super Star Club',
    1: 'One Star Club',
    2: 'Two Star Club',
    3: 'Three Star Club',
    4: 'Four Star Club',
    5: 'Five Star Club',
    6: 'Six Star Club',
    7: 'Seven Star Club',
    8: 'Eight Star Club',
    9: 'Nine Star Club',
    10: 'Ten Star Club'
  },
  changePassword: {
    text: 'Change Password',
    current: 'Current Password',
    new: 'New Password',
    repeat: 'Confirm Password',
    confirm: 'Confirm'
  },
  linkEmail: {
    text: 'Link Your Email',
    writeYourEmail:
      'Write your email here and we will send you code for verification',
    emailAddress: 'Email Address',
    resendCode: 'Resend verifictaion code',
    checkYourMail:
      'Please check your verification code in mailbox, it may be the spam box',
    verificationCode: 'Verification Code',
    unverifiedCode: 'Incorrect verification code',
    alreadyLinked: 'Already Linked'
  },
  passwordRecovery: {
    emailField: 'Email Address',
    title: 'Password Recovery',
    description: 'Write your email address which you used in registration.',
    sendEmail: 'Send Email',
    successDescription:
      'We send you a new temporary password. You can use it in order to enter the game, After signing in you can change the password in the Game Settings Menu',
    goBack: 'Go Back'
  },
  tutorial: {
    text: 'Tutorial',
    accountSettings: 'Account Settings',
    leagueGames: 'League Games',
    clubs: 'Clubs',
    shop: 'Shop',
    dailyBonus: 'Daily Bonus',
    accountLevelsAndXP: 'Account levels and XP',
    friendInvite: 'Friend invite'
  },
  about: {
    text: 'About',
    gameRules: 'Game Rules',
    contactInfo: 'Contact Info',
    termsAndConditions: 'Terms and conditions',
    privacyPolicy: 'Privacy policy'
  },
  leaderboard: {
    text: 'Leaderboard',
    remaining: 'Time Remaining',
    rank: 'Rank',
    name: 'Name',
    points: 'Your Points',
    reward: 'Reward',
    daily: 'daily',
    weekly: 'weekly',
    monthly: 'monthly'
  },
  leaderboardInfo: {
    text: 'Leaderboard Info',
    hints: 'Hints',
    rewards: 'Rewards'
  },
  leaderboardHints: {
    text: 'Hints',
    rule:
      'By playing games in league or club player will earn points and participate on Leaderboards. By the end of the timer players who are in the top ten will receive rewards.',
    hintsText: [
      {
        header: 'Hint 1.',
        text:
          'You can earn Leaderboard points by playing poker, casino games and doing bets in league and clubs.'
      },
      {
        header: 'Hint 2.',
        text:
          'Playing games and doing bettings in clubs will give you more points than league games'
      },
      {
        header: 'Hint 3.',
        text:
          'Points are defined by the amount of money you win, big bet will give you bigger reward and also a lot of points.'
      },
      {
        header: 'Hint 4.',
        text:
          'Your points will reset when timer ends. But if you didn’t manage to get into top 20 in Daily Leaderboards you will still have a chance to increase that points and get into Top 20 in Weekly or Monthly Leaderboards.'
      }
    ]
  },
  level: {
    currentXp: 'Current XP',
    requiredXp: 'Required XP',
    gainXp: ' Play poker, casino or do in order to gain XP and level up',
    accountLevel: 'Account Level',
    levelRewards: 'Level {0} Rewards'
  },
  shop: {
    text: 'Shop',
    coins: {
      text: 'Coins'
    },
    items: {
      text: 'Items',
      silverCard: 'Siver Card',
      goldCard: 'Gold Card',
      platinumCard: 'Platinum Card',
      avatars: 'Avatars',
      emojis: 'Emojis'
    },
    sapphires: {
      text: 'Sapphires'
    },
    mostPopular: 'Most Popular',
    bestValue: 'Best Value'
  },
  support: {
    text: 'Support'
  },
  time: {
    s15: '15s',
    s20: '20s',
    s30: '30s'
  },
  number: {
    one: '1',
    onePointFive: '1.5',
    two: '2',
    twoPointFive: '2.5',
    three: '3',
    fout: '4',
    five: '5',
    six: '6'
  },
  dash: {
    claimBack: 'Claim-back',
    buyIn: 'Buy-in'
  },
  button: {
    ok: 'OK',
    confirm: 'Confirm',
    cancel: 'Cancel',
    claimBack: 'Claim Back',
    sendOut: 'Send Out',
    send: 'Send',
    oneMore: 'One More',
    buy: 'Buy',
    done: 'Done',
    submit: 'Submit',
    quit: 'Quit The Club',
    sapphire: 'Sapphire',
    select: 'Select',
    save: 'Save',
    sendVip: 'Send VIP',
    upgrade: 'Upgrade',
    close: 'Close',
    create: 'Create',
    join: 'Join',
    apply: 'Apply',
    claim: 'Claim',
    linkYourEmail: "Link your Email"
  },
  header: {
    clubData: 'Club Data',
    clubDetails: 'Club Details',
    clubChips: 'Club Chips',
    clubRating: 'Club Rating',
    title: 'Title'
  },
  playerMenu: {
    playerMenuTitle: 'Player Details',
    trade: 'Trade Record',
    jackpot: 'Jackpot',
    quit: 'Quit The Club'
  },
  agentMenu: {
    agentMenuTitle: 'Agent Details',
    grantCredit: 'Grant Credit'
  },
  career: {
    items: {
      poker: 'Hands',
      sportsbook: 'Bets',
      casino: 'Bets'
    },
    periods: {
      day: 'day',
      month: 'month',
      year: 'year'
    },
    range: {
      all: 'All time',
      lastWeek: 'Last 7 days',
      purchase: 'Purchase Gold card or above for more detailed data'
    },
    reports: {
      game: 'Game',
      hand: 'Hand'
    },
    menu: {
      filters: 'Filters'
    },
    menuRow: {
      all: 'All',
      poker: 'Poker',
      casino: 'Casino',
      betting: 'Betting'
    }
  },
  options: {
    // text: "Options",
    clubChips: '{1} Chips {0}',
    newMessage: 'Notifications',
    buyLevel: 'Club Rating LVL {0}',
    promotion: 'Promotion',
    disband: 'Disband the Club',
    leftDays: '({0} days left)',
    grandCredit: 'Grand Credit History',
    quit: 'Quit The Club'
  },
  union: {
    clubs: 'Union Clubs',
    requests: 'Join Requests',
    data: 'Union Data',
    authority: 'Authority to Create Poker Tables',
    disband: 'Disband The Union',
    quit: 'Quit The Union'
  },
  club: {
    text: 'Club',
    poker: 'Poker',
    betting: 'Betting',
    casino: 'Casino',
    games: {
      poker: {
        admin:
          'Currently Casino games are not available. In order to make it available, please Renew your Club rating',
        member: 'Currently there are no any Poker tables available'
      },
      casino: {
        admin:
          'Currently Casino games are not available. In order to make it available, please Renew your Club rating',
        member: 'Casino games are not available at the moment'
      },
      betting: {
        admin:
          'Currently Betting is not available. In order to make it available, please Renew your Club rating',
        member: 'Betting is not available at the moment',
        enterText: 'Press on the button in order to enter sports section',
        goToSports: 'Go To Sports'
      },
      renew: 'Renew'
    }
  },
  clubItems: {
    options: 'Club Options',
    notifications: 'Notifications',
    members: 'Member Details',
    counter: 'Counter',
    tradeRecords: 'Trade Records',
    memberDetails: 'Member Details',
    clubRatings: 'Club Ratings',
    claimBack: 'Claim Back',
    sendOut: 'Send Out',
    data: 'Club Data',
    union: 'Union',
    unionEditing: 'Union Editing',
    agentMenu: 'Agent Menu'
  },
  memberDetails: {
    trackPlayer: 'Track Player',
    roleSelection: 'Role Selection',
    clubRatings: 'Club Ratings',
    editMemberInfo: {
      alias: 'Add Alias',
      notes: 'Add Notes'
    }
  },
  tradeDirection: {
    sent: 'Sent to:',
    claimedBack: 'Claimed from:'
  },
  members: 'Members',
  newMembers: 'New Members',
  betting: 'Sport',
  title: 'Title',
  chips: 'Chips',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  repeatPassword: 'Repeat Password',
  email: 'Email',
  login: 'Login',
  version: 'Version',
  loginObj: {
    text: 'Dont have an account? ',
    link: 'Register Now!'
  },
  registerObj: {
    text: 'Already have an account? ',
    link: 'Sign in'
  },
  forgotPassword: 'Forgot Password',
  loginBonus: 'Login Bonus',
  insurance: 'Insurance',
  totalPokerFees: 'Total Poker Fees',
  pokerFees: 'Poker Fees',
  totalWinnings: 'Total Winnings',
  winningsLastWeek: 'Winnings Last Week',
  winningsThisweek: 'Winnings this Week',
  downlinesChips: "Downline's Chips",
  chipsInPlay: 'Chips In Play',
  invalidEmail: 'Email is Invalid',
  fullScreenHint:'Press on "aA" button than select "Hide ToolBar" button for full screnn',
  dismissFullScreen: 'Dismiss Full screen',
  lastWeek: 'Last Week',
  currentWeek: 'Current Week',
  last24Hour: "Last 24h",
  customRange: "Custom Range",
  lastMonth: "Last Month",
  date: "Date",
  type: "Type",
  gameTransfers: "Game Transfers",
  transfers: "Transfers",
  all: "All",
  signIn: "Sign In",
  signUp: "Sign Up",
  aboutUs: "About Us",
  edit: "Edit",
  country: "Country",
  nameOfTable: "Name of Table",
  actionTime: "Action Time",
  min: "Min",
  max: "Max",
  month: "Month",
  day: "Day",
  week: "Week",
  filter: "Filter",
  downlines: "Downlines",
  ownerChipsAmount: "Owner Chips amount",
  agentChipsAmount: "Agent Chips Amount",
  youDontHaveAnyMessages: "You don’t have any messages",
  enterTheClubID: "Enter The Club ID",
  titleIsLimitedToLetters: "Title is Limited to 20 letters",
  areYouSureYouWantToQuitTheClub: "Are you sure you want to quit the club ?",
  casinoIsLoading: "Casino is loading",
  sportsIsLoading: "Sports is loading",
  tableIsLoading: "Table is loading",
  dearCustomer: "Dear Customer",
  yourAccountPrivileges: "Your account privileges in {0} club has been changed to agent",
  removeFromClubNotification: "Remove from Club Notification",
  dear: " Dear {0}",
  feedbackHistory: "Feedback history",
  writeTheReportHere: "Write the report here",
  youCanWriteYourSuggestions: "You can write your suggestions and bug reports to our support team.We will be happy to help you.",
  hello: "Hello",
  casino: 'Casino',
  liveCasino: 'Live Casino',
  poker: 'Poker',
  sport: 'Sport',
  gameId: {
    poker: "Table ID",
    casino: "Game ID",
    liveCasino: "Game ID",
    sport: "Match ID",
  },
  buyin: "Buy in", 
  buyout: "Buy out",
  noDataAvailableInviteFriends: "No data available, invite friends to play now",
  agencyBalance: "Agency Balance",
  lvl: "Lvl",
  freeToRenameForTheFirstTime: "Free to rename for the first time",
  clubRatingIsExpired: "Club Rating is expired, please purchase it again",
  renew: "Renew",
  tokenIsReceived: "Token is received",
  openApp :"Open App",
  plo4: "PLO4",
  plo5: "PLO5",
  capado: "PLO CAPADO",
  clubLobbyIsLoading: "Loading Club Lobby"
};
